import * as XLSX from 'xlsx';
import { parseFecha, horaAMinutos } from '../horarios/time';

export const DIAS_TODOS = ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO', 'DOMINGO'];

function normalizarEncabezado(texto) {
  return String(texto)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quita acentos
    .trim()
    .toUpperCase();
}

function buscarValor(fila, ...nombresPosibles) {
  const buscados = nombresPosibles.map(normalizarEncabezado);
  for (const clave of Object.keys(fila)) {
    if (buscados.includes(normalizarEncabezado(clave))) {
      return fila[clave];
    }
  }
  return undefined;
}

export async function parseArchivoAcomodamiento(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });
  const primeraHoja = workbook.Sheets[workbook.SheetNames[0]];
  const filasCrudas = XLSX.utils.sheet_to_json(primeraHoja, { defval: '' });

  const filas = filasCrudas.map((filaCruda, indice) => {
    const semestre = buscarValor(filaCruda, 'SEMESTRE');
    const id = buscarValor(filaCruda, 'ID');
    const horaInicioMin = horaAMinutos(buscarValor(filaCruda, 'HORA INICIO'));
    const horaFinMin = horaAMinutos(buscarValor(filaCruda, 'HORA FIN'));
    const fechaInicio = parseFecha(buscarValor(filaCruda, 'FECHA INICIO'));
    const fechaFin = parseFecha(buscarValor(filaCruda, 'FECHA FIN'));

    const dias = DIAS_TODOS.filter((dia) => {
      const valor = buscarValor(filaCruda, dia);
      return valor !== undefined && String(valor).trim() !== '';
    });

    return {
      fila: indice + 2, // +2: encabezado + índice base 1, para mensajes de error legibles
      semestre,
      id,
      horaInicioMin,
      horaFinMin,
      dias,
      fechaInicio,
      fechaFin,
    };
  });

  const errores = [];
  filas.forEach((f) => {
    if (!f.semestre) errores.push(`Fila ${f.fila}: falta SEMESTRE`);
    if (!f.id) errores.push(`Fila ${f.fila}: falta ID`);
    if (f.horaInicioMin === null || f.horaFinMin === null) {
      errores.push(`Fila ${f.fila}: falta HORA INICIO o HORA FIN`);
    } else if (f.horaFinMin <= f.horaInicioMin) {
      errores.push(`Fila ${f.fila}: HORA FIN debe ser mayor que HORA INICIO`);
    }
    if (f.dias.length === 0) errores.push(`Fila ${f.fila}: no tiene ningún día marcado (LUNES...DOMINGO)`);
    if (!f.fechaInicio || !f.fechaFin) errores.push(`Fila ${f.fila}: falta FECHA INICIO o FECHA FIN`);
  });

  return { filas, errores };
}
